import {
    FAKE_ENV_FOR_TESTING,
    GAINSIGHT_CUSTOM_EVENT_PREFIX,
    GAINSIGHT_TAG_KEY,
} from "../../config";

export enum GainsightEvent {
    OpenNotFoundPage = "OPEN_NOT_FOUND_PAGE",
    OpenPaymentRequestsTab = "OPEN_PAYMENT_REQUESTS_TAB",
    OpenPaymentPlansTab = "OPEN_PAYMENT_PLANS_TAB",
    OpenPaymentMethodsTab = "OPEN_PAYMENT_METHODS_TAB",
    OpenDocumentsPreview = "OPEN_DOCUMENTS_PREVIEW",
    OpenPaymentRequestAlreadyPaidModal = "OPEN_PAYMENT_REQUEST_ALREADY_PAID_MODAL",
    ChangeLanguage = "CHANGE_LANGUAGE",
    ChangeSelectedInstallments = "CHANGE_SELECTED_INSTALLMENTS",
    ChangeSelectedPaymentPlan = "CHANGE_SELECTED_PAYMENT_PLAN",
    ChangePayNow = "CHANGE_PAY_NOW",
    ChangeSelectedPaymentMethod = "CHANGE_SELECTED_PAYMENT_METHOD",
    ConfirmPayment = "CONFIRM_PAYMENT",
    ConfirmPaymentRequestIsAlreadyPaid = "CONFIRM_PAYMENT_REQUEST_IS_ALREADY_PAID",
    DownloadDocument = "DOWNLOAD_DOCUMENT",
    DownloadReceipt = "DOWNLOAD_RECEIPT",
    ProceedToPayment = "PROCEED_TO_PAYMENT",
    CreatePayment = "CREATE_PAYMENT",
    UpdatePayment = "UPDATE_PAYMENT",
    OpenPaymentAlreadyExistModal = "OPEN_PAYMENT_ALREADY_EXIST_MODAL",
    OpenPaymentSolutionsModal = "OPEN_PAYMENT_SOLUTIONS_MODAL",
}

declare const window: Window & {
    aptrinsic?: any;
};

interface IGainsightIdentifyOptions {
    user: {
        id: string;
    };
}

function bootstrap() {
    if (GAINSIGHT_TAG_KEY && !FAKE_ENV_FOR_TESTING) {
        window.aptrinsic =
            window.aptrinsic ||
            function () {
                window.aptrinsic.q = window.aptrinsic.q || [];
                window.aptrinsic.q.push(arguments);
            };
        window.aptrinsic.p = GAINSIGHT_TAG_KEY;

        const aptrinsicScript = document.createElement("script");
        aptrinsicScript.async = true;
        aptrinsicScript.src = `https://web-sdk.aptrinsic.com/api/aptrinsic.js?a=${GAINSIGHT_TAG_KEY}`;

        const firstScript = document.getElementsByTagName("script")[0];
        firstScript.parentNode!.insertBefore(aptrinsicScript, firstScript);
    }
}

function identify({ user }: IGainsightIdentifyOptions) {
    if (window.aptrinsic) {
        const screenResolution = `${window.screen.width}x${window.screen.height}`;
        window.aptrinsic("identify", { ...user, screenResolution });
    }
}

export function bootstrapAndIdentify(
    identifyOptions: IGainsightIdentifyOptions
) {
    bootstrap();
    identify(identifyOptions);
}

export const trackEvent = (event: GainsightEvent, details?: any) => {
    window.aptrinsic &&
        window.aptrinsic(
            "track",
            `${GAINSIGHT_CUSTOM_EVENT_PREFIX}:${event}`,
            details
        );
};
